/* 🤖 this file was generated by svg-to-ts */
export const matIconSwitchLeft: {
  name: 'switch-left';
  data: string;
} = {
  name: 'switch-left',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M8.5 8.62v6.76L5.12 12 8.5 8.62M10 5l-7 7 7 7V5zm4 0v14l7-7-7-7z"/></svg>`
};
